import * as angular from 'angular';
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";

export class AgentAssignTableItemComponent implements IController {
  agent: AgentModel;
  columns: any;
  logisticsVehiclesList: LogisticsVehicle[]
  score: any;
  availableSchedules: any;
  contractPrice: string;
  isLinkedAgent: boolean;
  isIgnoreScore: boolean;
  onAssign: Function;
}

angular
  .module('bringoz.admin.agents')
  .component('agentAssignTableItem', {
    bindings: {
      agent: '<',
      columns: '<',
      logisticsVehiclesList: '<',
      score: '<',
      availableSchedules: '<',
      contractPrice: '<',
      isLinkedAgent: '<',
      isIgnoreScore: '<',
      onAssign: '&'
    },
    template: require('./agent-assign-table-item.html').default,
    controller: AgentAssignTableItemComponent
  });
